import React from 'react';
import { Grid, Skeleton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import SquareIcon from '@mui/icons-material/Square';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: `${theme.spacing(2.5)} ${theme.spacing(2.5)} 0 ${theme.spacing(
      2.5
    )}`,
    marginRight: theme.spacing(3),
    marginTop: theme.spacing(3)
  },
  heading: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: theme.spacing(2.6),
    width: theme.spacing(15)
  },
  legendText: {
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.caption.fontWeight,
    width: theme.spacing(8)
  },
  legendIcon: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    marginRight: theme.spacing(0.4),
    color: theme.palette.grey[300]
  },
  barChartSkeleton: {
    width: theme.spacing(4),
    height: theme.spacing(25)
  },
  barChartSkeletonContainer: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }
}));

const MyUtilizationChartSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid container data-testid={'my-utilization-chart-skeleton'}>
      <Grid item container>
        <Grid item xs={4} container alignItems={'center'}>
          <Skeleton variant="text" className={classes.heading} />
        </Grid>
        <Grid container item xs={8}>
          {Array.from(new Array(5)).map((_x, index) => (
            <Grid
              key={index}
              container
              item
              xs={4}
              sm={4}
              md={4}
              lg={2}
              direction={'row'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <SquareIcon fontSize="small" className={classes.legendIcon} />
              <Skeleton variant="text" className={classes.legendText} />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid
        item
        container
        justifyContent={'space-between'}
        alignItems={'center'}
        className={classes.barChartSkeletonContainer}
      >
        {Array.from(new Array(5)).map((_x, index) => (
          <Grid
            key={index}
            xs={2}
            item
            container
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Skeleton
              variant="rectangular"
              className={classes.barChartSkeleton}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default React.memo(MyUtilizationChartSkeleton);
